import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import { mapState } from 'vuex';
import ProfileSettings from '~/components/settings/ProfileSettings';
import AlertsSettings from '~/components/settings/AlertsSettings';
import MySecuritySettings from '~/components/settings/MySecuritySettings';
import LoadingOverlay from '~/components/LoadingOverlay';
export default {
  name: "MySettings",
  components: {
    LoadingOverlay: LoadingOverlay,
    ProfileSettings: ProfileSettings,
    AlertsSettings: AlertsSettings,
    MySecuritySettings: MySecuritySettings
  },
  data: function data() {
    return {
      subscriptionModalDisplay: false,
      subscriptionTemporary: null,
      tabs: {
        '#profile-account': {
          name: "pages.settings.profile",
          icon: "mdi-account-outline",
          componentType: "profile-settings",
          ref: "profile",
          update: "profile",
          permissions: true
        },
        '#profile-security': {
          name: "pages.settings.my_security",
          icon: "mdi-security",
          componentType: "my-security-settings",
          ref: "security",
          update: "security",
          permissions: true
        },
        '#personal-dossier-options': {
          name: "pages.settings.personal_dossier_settings",
          icon: "mdi-folder-alert-outline",
          componentType: "alerts-settings",
          ref: "personal_dossiers_settings",
          value: this.$store.state.settings.me.personal_dossiers_settings,
          update: "personal_dossiers_settings",
          permissions: "personalDossiersSettingsDisplay",
          withAlertSwitch: true
        }
      }
    };
  },
  fetch: function fetch() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.$store.dispatch("formData/getSettings");
          case 2:
            _context.next = 4;
            return _this.$store.dispatch("settings/getMe");
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  head: function head() {
    return {
      title: this.$t("pages.layout.my_settings")
    };
  },
  computed: _objectSpread(_objectSpread({
    selectedTab: {
      get: function get() {
        return this.$route.hash || "#profile-account";
      },
      set: function set() {}
    }
  }, mapState({
    personalDossiersSettingsDisplay: function personalDossiersSettingsDisplay(state) {
      var _state$settings$me, _state$settings$me$pe;
      return !!((_state$settings$me = state.settings.me) !== null && _state$settings$me !== void 0 && (_state$settings$me$pe = _state$settings$me.personal_dossiers_settings) !== null && _state$settings$me$pe !== void 0 && _state$settings$me$pe.alerts) && Object.keys(state.settings.me.personal_dossiers_settings.alerts).length !== 0;
    },
    changedLang: function changedLang(state) {
      return state.settings.me.profile.language.value !== state.auth.user.lang;
    },
    selectedLang: function selectedLang(state) {
      return state.settings.me.profile.language.value;
    },
    error: function error(state) {
      return state.settings.error;
    }
  })), {}, {
    isMaster: function isMaster() {
      return this.$store.getters["permissions/userIsMaster"];
    },
    filteredTabs: function filteredTabs() {
      var tabs = {};
      for (var keyTabs in this.tabs) {
        var tab = this.tabs[keyTabs];
        if (Object.prototype.hasOwnProperty.call(tab, "permissions")) {
          var permissions = tab.permissions;
          if (permissions === true || this.isAFunction(permissions)) {
            tabs = _objectSpread(_objectSpread({}, tabs), {}, _defineProperty({}, keyTabs, _objectSpread({}, tab)));
          }
        }
      }
      return tabs;
    }
  }),
  watch: {
    isMaster: function isMaster(newCount, oldCount) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$store.dispatch("settings/getMe");
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.unsubscribe = this.$store.subscribeAction({
      after: this.subscribeUpdateSettings
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribe();
  },
  mounted: function mounted() {},
  methods: {
    updateProfile: function updateProfile() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var updateTypeData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              updateTypeData = _this3.tabs[_this3.selectedTab].update;
              if (!_this3.changedLang) {
                _context3.next = 6;
                break;
              }
              _context3.next = 4;
              return _this3.$helpers.changeLanguage({
                lang: _this3.selectedLang,
                mute: true
              });
            case 4:
              _context3.next = 6;
              return _context3.sent;
            case 6:
              _context3.next = 8;
              return _this3.$store.dispatch("settings/updateSettings", {
                updateTypeData: updateTypeData
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    subscribeUpdateSettings: function subscribeUpdateSettings(action, state) {
      if (action.type === "settings/updateSettings") {
        if (this.error !== null) {
          this.catchUpdateProfile(this.error._data);
        }
      }
    },
    catchUpdateProfile: function catchUpdateProfile(err) {
      var currentRef = this.tabs[this.selectedTab].ref;
      var updateTypeData = this.tabs[this.selectedTab].update;
      var updateErrors = (err === null || err === void 0 ? void 0 : err[updateTypeData]) || err;
      console.log("error catchUpdateProfile", currentRef, updateErrors);
      this.setErrors("currentComponent".concat(currentRef), updateErrors);
    },
    changeSubscription: function changeSubscription(_ref) {
      var name = _ref.name;
      if (!!name) {
        this.subscriptionTemporary = name;
        this.subscriptionModalDisplay = true;
      }
    },
    closeSubscription: function closeSubscription(_ref2) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _ref2$confirm, confirm;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref2$confirm = _ref2.confirm, confirm = _ref2$confirm === void 0 ? false : _ref2$confirm;
              _context4.t0 = !!confirm;
              if (!_context4.t0) {
                _context4.next = 5;
                break;
              }
              _context4.next = 5;
              return _this4.configSubscription();
            case 5:
              _this4.subscriptionTemporary = null;
              _this4.subscriptionModalDisplay = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    configSubscription: function configSubscription() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.$store.commit("settings/SET_VALUE", {
                namespace: "subscription",
                key: "name",
                value: _this5.subscriptionTemporary
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    setErrors: function setErrors(ref, err) {
      if (!!err) {
        var _this$$refs$ref, _this$$refs$ref$;
        this === null || this === void 0 ? void 0 : (_this$$refs$ref = this.$refs[ref]) === null || _this$$refs$ref === void 0 ? void 0 : (_this$$refs$ref$ = _this$$refs$ref[0]) === null || _this$$refs$ref$ === void 0 ? void 0 : _this$$refs$ref$.setErrors(err);
      }
    },
    isAFunction: function isAFunction(arg) {
      return _typeof(arg) === "string" && !!this[arg];
    }
  }
};